const SIZE_X = 76;
const SIZE_Y = 41;

const DEFAULT_IN_RANGE = {
  min: 0,
  max: 1,
};

export const normalize = (data: Json) => {
  const xPercent = data.x / SIZE_X / 2;
  const yPercent = 1 - data.y / SIZE_Y / 2;

  const x = changeRange(xPercent, { min: 0, max: 1 }, { min: 0, max: 1 });
  const y = changeRange(yPercent, { min: 0, max: 1 }, { min: 0, max: 1 });

  return { x, y };
};

type Range = {
  min: number;
  max: number;
};

export const changeRange = (value: number, from: Range, to: Range) => {
  const fromRange = from.max - from.min;
  const toRange = to.max - to.min;
  return ((value - from.min) * toRange) / fromRange + to.min;
};

type Position = { x: number; y: number };

export const normalizeIn = (pos: Position): Position => {
  const output = { ...pos };

  output.x = changeRange(pos.x, { min: 0, max: 1 }, { min: 0, max: SIZE_X * 2 * 0.89 });
  output.y = changeRange(pos.y, { min: 0, max: 1 }, { min: (SIZE_Y * 2) / 1.24, max: 0 });

  return output;
};
